import { Attachment } from '@panaya/ai-chat/shared';
import { RequirementPickResult } from './model/requirement-pick-result.model';

/**
 * Maps the requirement dialog's selection to chat attachments, labelled as the dialog shows them ("512: Name"), with
 * the requirement's type as the chip's detail. The type is the customer's own name for it, shown untranslated.
 */
export function toRequirementAttachments(result: RequirementPickResult): Attachment[] {
    return result.gridSelectionDetails.map((row) => ({
        resourceType: 'requirement',
        type: 'requirement',
        reference: String(row.param1),
        label: `${row.resultDisplayedId}: ${row.testName}`,
        ...(row.typeDescription ? { detail: row.typeDescription } : {})
    }));
}
